import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Module, ModuleIgnoreList } from '../models/module.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class ModuleService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Module', httpClient, toastrService, url);
  }

  putModule(moduleId: number, module: Module, afterPutCallback?: Function, customMessage?: string): void {
    return this.putNow('/module/' + moduleId, this.getBody(module, ModuleIgnoreList), afterPutCallback, customMessage);
  }
}
